import React    from "react"
import Checkbox from "@shared/checkbox/checkbox"

const DEFAULT_WIDGET_WIDTH = 1

const WidgetSelector = ({ widgetTemplates, selected, setSelected }) => {
  const isSelected = identifier => selected.some(widget => widget.identifier === identifier)
  
  const toggle = widget => {
    setSelected(prev => {
      if (prev.some(w => w.identifier === widget.identifier)) {
        return prev
          .filter(w => w.identifier !== widget.identifier)
          .map((w, index) => ({ ...w, order: index + 1 }))
      } else {
        return [...prev, { 
          identifier: widget.identifier, 
          width: DEFAULT_WIDGET_WIDTH,
          order: prev.length + 1 
        }]
      }
    })
  }
  
  return (
    <>
      {widgetTemplates.length === 0 ? (
        <div>{I18n.t("export.no_available_widgets")}</div>
      ) : (
        widgetTemplates.map((widget) => (
          <Checkbox
            key       = {widget.identifier}
            checked   = {isSelected(widget.identifier)}
            id        = {widget.identifier}
            onChange  = {() => toggle(widget)}
            label     = {widget.title}
            className = "form-group"
          />
        ))
      )}
    </>
  )
}

export default WidgetSelector